import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { EERIE } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import UIClickable from 'UIComponents/button/UIClickable';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIImage from 'UIComponents/image/UIImage';
import { Fragment } from 'react';
import { ProductToIconMap } from '../../../constants/merchCards/ProductToIconMap';
import { STARTER } from 'self-service-api/constants/ProductLevels';
import FeatureTableRow from '../FeatureTableRow';
import { ExpandableSectionLabel, ExpandableTableContent, ExpandTableButtonContainer } from './SuiteFeatureTableComponents';
import UIButton from 'UIComponents/button/UIButton';
export const SuiteFeatureTableContent = ({
  productLine,
  localFeatures,
  highlightedProducts,
  levels,
  handleExpandSectionChange,
  isSectionExpanded,
  handleExpandFeatureTableChange,
  isFeatureTableExpanded
}) => {
  if (!highlightedProducts.length) return null;
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(ExpandableSectionLabel, {
      children: /*#__PURE__*/_jsx("tr", {
        children: /*#__PURE__*/_jsx("td", {
          colSpan: levels.size + 1,
          children: /*#__PURE__*/_jsx(UIClickable, {
            onClick: () => handleExpandSectionChange(productLine),
            "aria-expanded": isSectionExpanded[productLine] ? 'true' : 'false',
            "aria-controls": `suite-feature-table-${productLine}-section`,
            children: /*#__PURE__*/_jsxs("div", {
              className: "display-flex align-center",
              children: [/*#__PURE__*/_jsx(UIImage, {
                src: ProductToIconMap[productLine][STARTER],
                width: "24",
                className: "m-right-3"
              }), /*#__PURE__*/_jsx("strong", {
                children: /*#__PURE__*/_jsx(FormattedReactMessage, {
                  message: `suiteFeatureTable.section.title`,
                  options: {
                    product: /*#__PURE__*/_jsx(FormattedMessage, {
                      message: `productLine.${productLine}`
                    })
                  }
                })
              })]
            })
          })
        })
      })
    }), /*#__PURE__*/_jsx(ExpandableTableContent, {
      id: `suite-feature-table-${productLine}-section`,
      isSectionExpanded: isSectionExpanded[productLine],
      isFeatureTableExpanded: isFeatureTableExpanded[productLine],
      children: localFeatures.map(feature => {
        return /*#__PURE__*/_jsx(FeatureTableRow, {
          highlightedProducts: highlightedProducts,
          feature: feature,
          productLine: productLine
        }, feature.featureId);
      })
    }), isSectionExpanded[productLine] && /*#__PURE__*/_jsx(ExpandTableButtonContainer, {
      children: /*#__PURE__*/_jsx("tr", {
        children: /*#__PURE__*/_jsx("td", {
          colSpan: levels.size + 1,
          className: "display-flex align-center",
          children: /*#__PURE__*/_jsxs(UIButton, {
            use: "transparent",
            onClick: () => {
              handleExpandFeatureTableChange(productLine);
            },
            "aria-expanded": isSectionExpanded[productLine] ? 'true' : 'false',
            className: "p-left-8",
            children: [/*#__PURE__*/_jsx(FormattedMessage, {
              message: isFeatureTableExpanded[productLine] ? `suiteFeatureTable.ebx633Collapse` : `suiteFeatureTable.ebx633Expand`
            }), /*#__PURE__*/_jsx(UIIcon, {
              name: isFeatureTableExpanded[productLine] ? 'upCarat' : 'downCarat',
              color: EERIE
            })]
          })
        })
      })
    })]
  }, productLine);
};